import { useMemo } from 'react';
import { useNativeState } from '@shared/core/native';
import { ACCOMMODATIONS_SLUG } from '../routes/GuestSite/GuestSite.routes';

/**
 * Determines page context for accommodations, including whether the app is running in native mode
 * and whether the current page slug matches the accommodations route.
 *
 * @param pageSlug - The current page's slug, typically from route or navigation context.
 * @returns An object containing:
 * - `isAccommodationsPage`: `true` if the slug matches the accommodations route.
 * - `isNativeAccommodationPage`: `true` if the app is in native mode and on the accommodations page.
 */
export const useAccommodationPageChecks = (pageSlug?: Readonly<string>) => {
  const { isNative } = useNativeState();

  return useMemo(() => {
    const isAccommodationsPage = pageSlug === ACCOMMODATIONS_SLUG;
    const isNativeAccommodationPage = isNative && isAccommodationsPage;

    return { isAccommodationsPage, isNativeAccommodationPage };
  }, [isNative, pageSlug]);
};
